import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: '100%',
    flex: 1,
    padding: theme.spacing(4),
    boxSizing: 'border-box',
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(5),
    padding: theme.spacing(5),
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  imagePanel: {
    flex: '0 1 auto',
    width: theme.spacing(92.5),
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  carousel: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  previewImage: {
    display: 'block',
    width: '100%',
    height: 'auto',
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
  },
  arrow: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(5),
    height: theme.spacing(5),
    padding: 0,
    border: 'none',
    borderRadius: '50%',
    cursor: 'pointer',
    fontSize: theme.spacing(2.5),
    color: theme.palette.text.primary,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)',
  },
  arrowLeft: {
    left: theme.spacing(1),
  },
  arrowRight: {
    right: theme.spacing(1),
  },
  dots: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  dot: {
    width: theme.spacing(1),
    height: theme.spacing(1),
    padding: 0,
    border: 'none',
    borderRadius: '50%',
    cursor: 'pointer',
    backgroundColor: theme.palette.action.disabled,
  },
  dotActive: {
    width: theme.spacing(1),
    height: theme.spacing(1),
    padding: 0,
    border: 'none',
    borderRadius: '50%',
    cursor: 'pointer',
    backgroundColor: theme.palette.primary.main,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(4),
    width: theme.spacing(53.5),
    maxWidth: '100%',
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: '100%',
  },
  lockIcon: {
    fontSize: theme.spacing(3.75),
    color: theme.palette.loading.main,
    flexShrink: 0,
  },
  title: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.text.primary,
    margin: 0,
  },
  subheading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.text.secondary,
    margin: 0,
  },
  features: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    width: '100%',
  },
  featureRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  checkIcon: {
    fontSize: '16px',
    color: theme.palette.text.primary,
    marginTop: theme.spacing(0.25),
    flexShrink: 0,
  },
  featureText: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.text.primary,
    margin: 0,
  },
  buttonRow: {
    display: 'flex',
  },
}))
